import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { BaseComponent } from '../../../../models/base/base-component';
import { map } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { ScreenService } from '../../../../services/screen-service.service';

@Component({
  selector: 'app-file-uploader-text',
  templateUrl: './file-uploader-text.component.html',
  styleUrls: ['./file-uploader-text.component.scss'],
  standalone: true,
  imports: [AsyncPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileUploaderTextComponent extends BaseComponent {
  @Input() public disabled = false;
  @Input() public error = false;
  @Input() public descriptionText = $localize`.png, .jpeg or .pdf up to 3 MB`;

  private screenService = inject(ScreenService);

  public uploadInstructionText$ = this.screenService.isMobile$.pipe(
    map(isMobile => {
      return isMobile ? `` : $localize` or drag and drop`;
    })
  );

  setupViews(): void {}
  setupBindings(): void {}
}
